import axios from "../api/axios";
const API_URL = process.env.REACT_APP_API_URL;
export const getPostalCodes = async (code: number): Promise<string> => {
    try {
      const response = await fetch(`https://apicarto.ign.fr/api/codes-postaux/communes/${code}`);    
      if (!response.ok) {
        throw new Error('Erreur lors de la récupération des données');
      }      
      const data = await response.json();
      if (data.length > 0) {
        return data[0].nomCommune; 
      } else {
        throw new Error('Aucune donnée trouvée pour ce code postal');
      }
      
    } catch (error) {
      console.error("Erreur: ", error);
      throw error;
    }
  };
  

// export const getCitiesByPostalCode = async (code: number) => {
//       await axios(`/api_alo/rne/cities/code-postal/${code}`)
//       .then( response => {
//         return response.data.data
//       })
//       .catch( error => {
//         throw error
//       })
//   };

export const getCitiesByPostalCode = async (code: number): Promise<string[]> => {
    try {
      const response = await fetch(`${API_URL}/rne/cities/code-postal/${code}`);    
      if (!response.ok) {
        throw new Error('Erreur lors de la récupération des données');
      }      
      const data = await response.json();
      return data.data
      
    } catch (error) {
      console.error("Erreur: ", error);
      throw error;
    }
  };

export const getCitiesByPostalCodeString = async (code: string): Promise<string[]> => {
    try {
      const response = await fetch(`${API_URL}/rne/cities/code-postal/${code}`);    
      if (!response.ok) {
        throw new Error('Erreur lors de la récupération des données');
      }      
      const data = await response.json();
      return data.data
      
    } catch (error) {
      console.error("Erreur: ", error);
      throw error;
    }
  };

export const getCitiesAndGraftByPostalCode = async (code: number): Promise<
  {
    villes: string[],
    greffe: string
  }> => {
    try {
      const response = await fetch(`${API_URL}/rne/code-postal/${code}`);    
      if (!response.ok) {
        throw new Error('Erreur lors de la récupération des données');
      }      
      const data = await response.json();
      return data.data
      
    } catch (error) {
      console.error("Erreur: ", error);
      throw error;
    }
  };
  
